import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SRACostSheetGlossaryVM } from '../../../models/SRACostSheetGlossary/SRACostSheetGlossaryVM';

import { CppSraCostSheetService } from '../../../services/cpp-sra-cost-sheet/cpp-sra-cost-sheet.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';

@Component({
  selector: 'app-cpp-sra-cost-sheet-glossary',
  templateUrl: './cpp-sra-cost-sheet-glossary.component.html',
  styleUrls: ['./cpp-sra-cost-sheet-glossary.component.scss']
})
export class CppSraCostSheetGlossaryComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  noticeData: Array<SRACostSheetGlossaryVM> = [];
  glossaryData: Array<SRACostSheetGlossaryVM> = [];

  constructor(
    private cppSraCostSheetService: CppSraCostSheetService,
    private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.getGlossaryData();
  }

  getGlossaryData(): any {
    this.loaderService.setLoaderStatus(true);
    this.noticeData = [];
    this.glossaryData = [];
    this.subscription.add(this.cppSraCostSheetService.getGlossaryData().subscribe((result) => {
      if (result) {
        this.noticeData = result.filter(x => x.type.trim().toLowerCase() === 'notice');
        this.glossaryData = result.filter(x => x.type.trim().toLowerCase() !== 'notice');
      }
      this.loaderService.setLoaderStatus(false);
    }, () => this.loaderService.setLoaderStatus(false)));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
